/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SchemaColumn { 
    /**
     * The name of the schema column. Required when Column is present
     */
    name: string;
    /**
     * The data type of the schema column. Required when Column is present
     */
    type: string;
    /**
     * The column size. This is a string value since, for \"NUMERIC\" and \"DECIMAL\" data types, we should be able to specify both                   the maximum number of digits (p) that are present in the number and the maximum number of decimal places (s) as a \"p,s\" string. Required when                   Column is present                
     */
    size?: string;
    /**
     * Values true|false. If true, a value isis required for the column (not nullable)
     */
    required?: boolean;
    /**
     * Default value for the column
     */
    defaultValue?: string;
    /**
     * Description of the column
     */
    description?: string;
}
